module.exports = __webpack_public_path__ + "img/chair_cool_on_border.fdaa2927.png";